// ANCHOR React
import { memo } from 'react';

// ANCHOR Base
import { LabelSmall } from 'baseui/typography';

// ANCHOR Models
import { ProviderData } from '@lyon/scoped-models/ProviderData';

// ANCHOR Styles
import { LABEL } from './styles';

export const LyonCourseCardProvider = memo(() => {
  const providerName = ProviderData.useSelector(({ data }) => data?.name);

  if (providerName) {
    return (
      <LabelSmall overrides={LABEL}>
        { providerName}
      </LabelSmall>
    );
  }

  return null;
});
